<div class="page-not-found">
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-8 col-lg-9 col-11 mx-auto">
                <div class="row align-items-center">
                    <div class="col-md-7 mb-md-0 mb-4">
                        <img src="../../../assets/images/404.png" class="w-100" alt="">
                    </div>
                    <div class="col-xl-4 col-md-5">
                        <p class="sorry">Sorry,</p>
                        <h4 class="f-mtit" *ngIf="!error">We cannot find the page.</h4>
                        <h4 class="f-mtit" *ngIf="error">Something going wrong.</h4>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <a routerLink="/home" class="btn to-home">
                        <img src="../../../assets/images/icon/arrow-big-right-2.png" alt="">
                        Home
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
